/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCastleIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-castle"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M0.68 18.68L0.68 10Q0.68 9.45 1.06 9.06Q1.45 8.68 2 8.68Q2.55 8.68 2.94 9.06Q3.33 9.45 3.33 10L3.33 10.68L4.67 10.68L4.67 4Q4.67 3.45 5.06 3.06Q5.45 2.67 6 2.67Q6.55 2.67 6.94 3.06Q7.33 3.45 7.33 4L7.33 4.67L8.68 4.67L8.68 4Q8.68 3.45 9.06 3.06Q9.45 2.67 10 2.67Q10.55 2.67 10.94 3.06Q11.32 3.45 11.32 4L11.32 4.67L12.68 4.67L12.68 4Q12.68 3.45 13.06 3.06Q13.45 2.67 14 2.67Q14.55 2.67 14.94 3.06Q15.32 3.45 15.32 4L15.32 4.67L16.68 4.67L16.68 4Q16.68 3.45 17.06 3.06Q17.45 2.67 18 2.67Q18.55 2.67 18.94 3.06Q19.32 3.45 19.32 4L19.32 10.68L20.68 10.68L20.68 10Q20.68 9.45 21.06 9.06Q21.45 8.68 22 8.68Q22.55 8.68 22.94 9.06Q23.32 9.45 23.32 10L23.32 18.68Q23.32 19.8 22.56 20.56Q21.8 21.32 20.68 21.32L15 21.32Q14.45 21.32 14.06 20.94Q13.68 20.55 13.68 20L13.68 18Q13.68 17.3 13.19 16.81Q12.7 16.32 12 16.32Q11.3 16.32 10.81 16.81Q10.32 17.3 10.32 18L10.32 20Q10.32 20.55 9.94 20.94Q9.55 21.32 9 21.32L3.33 21.32Q2.2 21.32 1.44 20.56Q0.68 19.8 0.68 18.68ZM9 12.32L11 12.32Q11.13 12.32 11.22 12.22Q11.32 12.13 11.32 12L11.32 10Q11.32 9.45 10.94 9.06Q10.55 8.68 10 8.68Q9.45 8.68 9.06 9.06Q8.68 9.45 8.68 10L8.68 12Q8.68 12.13 8.78 12.22Q8.88 12.32 9 12.32ZM13 12.32L15 12.32Q15.13 12.32 15.22 12.22Q15.32 12.13 15.32 12L15.32 10Q15.32 9.45 14.94 9.06Q14.55 8.68 14 8.68Q13.45 8.68 13.06 9.06Q12.68 9.45 12.68 10L12.68 12Q12.68 12.13 12.78 12.22Q12.88 12.32 13 12.32Z" fill={color} />
    </svg>
  );
}
